module.exports = __webpack_public_path__ + "img/Muses-ex-Echoes1.08a5f7a6.png";